export default __webpack_public_path__ + "static/media/G89A8020copy.8d5a0266.jpg";